import { Deserializable } from "@app/interfaces/deserializable";
import { CustomerAgreement } from "@app/models/customer-agreement";

export class Webauthentication  implements Deserializable {
    
    id: number;
    co: string;
    userName: string;
    acctNum: string;    
    accountDisabledFlag: boolean;
    password: string;
    passwordExpirationTime: Date;
    userNameUpdateDate: Date;
    passwordUpdateDate: Date;
    failedLoginCount: number;
    lastSuccessfulLoginDate: Date;
    micaAccountName: string;
    accountFrozenFlag: boolean;
    customerAgreementList: CustomerAgreement[];
    token: string;

    deserialize(input: any) {
        Object.assign(this, input);
        return this;
    }
}
